/* Polyfill browser that does not have modern attr() support */
if (!CSS.supports("x: attr(x type(*))")) {
  const selectors = [
    `[data-animation]`,
    `[data-animation-duration]`,
    `[data-animation-delay]`
  ];
  
  for (const element of document.querySelectorAll(selectors.join(","))) {
    const name = element.getAttribute("data-animation");
    const duration = element.getAttribute("data-animation-duration");
    const delay = element.getAttribute("data-animation-delay");

    if (name) {
      element.style.animationName = name;
    }

    if (duration) {
      element.style.animationDuration = `${duration}s`;
    }
    if (delay) {
      element.style.animationDelay = `${delay}s`;
    }
  }
}